module.exports = __webpack_public_path__ + "img/profitability3.e40e06f0.png";